module.exports = __webpack_public_path__ + "img/product-13.bf26d224.jpg";